(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider'];

    function stateConfig($stateProvider, $stickyStateProvider) {
        $stateProvider
            .state('invoice-sale', {
                parent: 'app',
                url: '/invoice/sale',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_JPN'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.sale.title',
                    title: 'Sale Invoices'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice/invoices.html',
                        controller: 'InvoiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function() {
                        return {
                            type: "SALE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-sale.all', {
                parent: 'app',
                url: '/invoice/sale/all',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_JPN'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.sale.title',
                    title: 'Sale Invoices'
                },
                views: {
                    'invoice-sale-all@': {
                        templateUrl: 'app/entities/invoice/invoices.html',
                        controller: 'InvoiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function() {
                        return {
                            type: "SALE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-sale.invoice-sale-detail', {
                parent: 'app',
                url: '/invoice/sale/{id}/detail',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI','ROLE_JPN'],
                    pageTitle: 'ccsTrApp.invoice.detail.title'
                },
                views: {
                    'invoice-sale-detail@': {
                        templateUrl: 'app/entities/invoice/invoice-detail.html',
                        controller: 'InvoiceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    category: function() {
                        return {
                            type: "SALE"
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('compType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', '$state', 'InvoiceDTO', function($stateParams, $state, InvoiceDTO) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return InvoiceDTO.get({id : paramId}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'invoice-sale',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('invoice-sale.new', {
                parent: 'app',
                url: '/invoice/sale/new?shipmentId',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.sale.create',
                    title: 'New'
                },
                views: {
                    'invoice-sale-new@': {
                        controller: 'InvoiceDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/invoice/invoice-dialog.html'
                    }
                },
                resolve: {
                    category: function() {
                        return {
                            type: "SALE"
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('wtUnitType');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('compType');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            createdOn: null,
                            createdBy: null,
                            modifiedOn: null,
                            modifiedBy: null,
                            invNum: null,
                            invType: "SALE",
                            currency: null,
                            label: null,
                            invDate: new Date(),
                            invDueDate: null,
                            estPayment: null,
                            status: "DRAFT",
                            wtPrecision: null,
                            invWtUnits: null,
                            invGrossKgs: null,
                            invNetKgs: null,
                            invTareKgs: null,
                            landedGrossKgs: null,
                            landedNetKgs: null,
                            landedTareKgs: null,
                            invGrossLbs: null,
                            invNetLbs: null,
                            invTareLbs: null,
                            landedGrossLbs: null,
                            landedNetLbs: null,
                            landedTareLbs: null,
                            invGrossMTs: null,
                            invNetMTs: null,
                            invTareMTs: null,
                            landedGrossMTs: null,
                            landedNetMTs: null,
                            landedTareMTs: null,
                            qtyBales: null,
                            totalValue: null,
                            editedTotalValue: 0,
                            editedTotalValueEur: 0,
                            ncontractValueEur: 0,
                            ncontractDate: null,
                            exchangeRate: 0,
                            balanceDue: null,
                            id: null,
                            selectedContract: null,
                            paymentBank: null,
                            commissionRate: 0,
                            pricePrecision: 3,
                            weightPrecision: 3,
                            valuePrecision: 3,
                            isProvisionalPrice: false
                        };
                    }
                }
            })
            .state('invoice-sale.edit', {
                parent: 'app',
                url: '/invoice/sale/{id}/edit',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'ccsTrApp.invoice.titleStatus.sale.edit',
                    title: 'Edit'
                },
                views: {
                    'invoice-sale-edit@': {
                        controller: 'InvoiceDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/entities/invoice/invoice-dialog.html'
                    }
                },
                resolve: {
                    category: function() {
                        return {
                            type: "SALE"
                        };
                    },
                    entity: ['$stateParams', '$state', 'Invoice', function( $stateParams, $state, Invoice ) {
                        var paramId = $stateParams.id > 0 ? $stateParams.id : $state.params.id;
                        return Invoice.get( { id: paramId } ).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function( $translate, $translatePartialLoader ) {
                        $translatePartialLoader.addPart('invoice');
                        $translatePartialLoader.addPart('keyword');
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('contract');
                        $translatePartialLoader.addPart('shipment');
                        $translatePartialLoader.addPart('lot');
                        $translatePartialLoader.addPart('fixation');
                        $translatePartialLoader.addPart('contract');
                        return $translate.refresh();
                    }]
                }
            }).state('invoice-sale.japan-report', {
            parent: 'app',
            url: '/invoice/japan/report',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_TUI'],
                pageTitle: 'Invoice Japan Report',
                title: 'Invoice Japan Report'
            },
            views: {
                'invoice-japan-report@': {
                    controller: 'InvoicesJapanReportController',
                    controllerAs: 'vm',
                    templateUrl: 'app/entities/invoice/invoice-japan-report.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('contract');
                    $translatePartialLoader.addPart('shipment');
                    $translatePartialLoader.addPart('lot');
                    $translatePartialLoader.addPart('fixation');
                    $translatePartialLoader.addPart('keyword');
                    $translatePartialLoader.addPart('comment');
                    $translatePartialLoader.addPart('invoiceStatus');
                    $translatePartialLoader.addPart('wtUnitType');
                    $translatePartialLoader.addPart('currencyType');
                    return $translate.refresh();
                }]
            }
        });

        $stickyStateProvider.enableDebug( true );

    }

})();
